'use client'

import {useTranslations} from '@/i18n/hooks/useTranslations'
import {useEffect} from 'react'
import * as CookieConsent from 'vanilla-cookieconsent'
import 'vanilla-cookieconsent/dist/cookieconsent.css'
import {type CookieConsentText, getConfig, SERVICE_ANALYTICS_STORAGE} from './CookieConsentConfig'

export const CookieConsentComponent = () => {
  const t = useTranslations()

  useEffect(() => {
    const contactLink = `<a href="/support">${t('cookies.contactUs')}</a>`
    const consentText: CookieConsentText = {
      acceptAllBtn: t('cookies.acceptAll'),
      acceptNecessaryBtn: t('cookies.rejectAll'),
      analyticsDescription: t('cookies.analyticsDescription'),
      analyticsTitle: t('cookies.analyticsTitle'),
      closeIconLabel: t('cookies.closeModal'),
      description: t('cookies.description'),
      footer: `<a href="/privacy" target="_blank">${t('cookies.privacyPolicy')}</a>`,
      googleAnalyticsDescription: t('cookies.analytics.googleAnalyticsDescription'),
      googleAnalyticsTitle: t('cookies.analytics.googleAnalyticsTitle'),
      moreInfoDescription: t('cookies.moreInfoDescription', {
        contactLink,
      }),
      moreInfoTitle: t('cookies.moreInfoTitle'),
      necessaryDescription: t('cookies.necessaryDescription'),
      necessaryTitle: t('cookies.necessaryTitle'),
      preferencesTitle: t('cookies.preferencesTitle'),
      privacyChoicesDescription: t('cookies.privacyChoicesDescription'),
      privacyChoicesTitle: t('cookies.privacyChoicesTitle'),
      savePreferencesBtn: t('cookies.savePreferences'),
      serviceCounterLabel: t('cookies.serviceCounter'),
      showPreferencesBtn: t('cookies.managePreferences'),
      tableHeaderDescription: t('cookies.tableHeaderDescription'),
      tableHeaderDomain: t('cookies.tableHeaderDomain'),
      tableHeaderName: t('cookies.tableHeaderName'),
      tableTitle: t('cookies.tableTitle'),
      title: t('cookies.title'),
    }

    CookieConsent.run(getConfig(consentText))
    if (window && window.gtag) {
      window.gtag('consent', 'default', {
        [SERVICE_ANALYTICS_STORAGE]: 'denied',
      })
    }
  }, [t])

  return (
    <button className="text-sm text-gray-300 hover:text-white cursor-pointer" onClick={CookieConsent.showPreferences}>
      {t('footer.cookies')}
    </button>
  )
}
